export default __webpack_public_path__ + "static/media/DDD-Chairside.c35f9d91.png";